import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import {
  getIconForMetricChange,
  getColorForMetricChangeValue
} from 'src/components/BeaconV2Components/utils/chartStyles';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { StacklineTextVariant } from '@stackline/ui';

export interface SlChangeAnnotationProps {
  /**
   * The value that will be formatted. It will be used
   * to determine which icon and color to use.
   */
  value: number;
  formattedValue: string;
  textVariant?: StacklineTextVariant;
}
export function SlChangeAnnotation({ value, formattedValue, textVariant = 'body4' }: SlChangeAnnotationProps) {
  return (
    <Flex gap="xs" alignItems="center">
      <div style={{ transform: 'translateY(1px)' }}>{getIconForMetricChange(value)}</div>
      <Text variant={textVariant} color={getColorForMetricChangeValue(value)}>
        {formattedValue}
      </Text>
    </Flex>
  );
}
